import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./contexts/AuthContext";

// Pages
import { LandingPage } from "./pages/Landing";
import { CourseCatalogPage } from "./pages/CourseCatalog";
import { CourseDetailPage } from "./pages/CourseDetail";
import { LessonPlayerPage } from "./pages/LessonPlayer";
import { AboutPage } from "./pages/About";
import { InstructorsPage } from "./pages/Instructors";
import { PurchaseSuccessPage } from "./pages/PurchaseSuccess";
import { PrivacyPage } from "./pages/Privacy";
import { TermsPage } from "./pages/Terms";
import { AppRegistrationPage } from "./pages/AppRegistration";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";

const container = document.querySelector("#root");
if (!container) {
  throw new Error("Root element not found");
}
const root = createRoot(container);

// Configure React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/courses" element={<CourseCatalogPage />} />
            <Route path="/courses/:courseId" element={<CourseDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/instructors" element={<InstructorsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/purchase/success" element={<PurchaseSuccessPage />} />
            <Route path="/app-registration" element={<AppRegistrationPage />} />
            
            {/* Protected routes */}
            <Route
              path="/my-courses"
              element={(
                <ProtectedRoute>
                  <CourseCatalogPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/my-courses/:courseId"
              element={(
                <ProtectedRoute>
                  <CourseDetailPage />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/lessons/:lessonId"
              element={(
                <ProtectedRoute>
                  <LessonPlayerPage />
                </ProtectedRoute>
              )}
            />
          </Routes>
        </Router>
        <Toaster
          position="top-right"
          toastOptions={{
            className: '',
            style: {
              background: '#001427',
              color: '#ffffff',
              border: '1px solid #9d7a1b',
            },
          }}
        />
      </AuthProvider>
    </QueryClientProvider>
  );
};

root.render(<App />);
